import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// const originalPush = VueRouter.prototype.replace
// VueRouter.prototype.replace = function replace(location) {
//   return originalPush.call(this, location).catch(err => err)

// }
const routes = [
    {
        path: "/error-unlogin",
        component: () => import("@/views/error/NoLoginError"),
    },

    {
        path: "/",
        component: () => import("@/views/layout/Layout"),
        redirect: '/home',
        children: [
            {
                path: "/home",
                name: "Flash",
                component: () => import("@/views/flash"),
            },
            {
                path: "/order",
                component: () => import("@/views/order/Order"),
            },
            {
                path: "/service",
                component: () => import("@/views/service/Service"),
            },
        ]
    },
    {
        path: "/detail",
        component: () => import("@/views/detail/Detail")
    },
    {
        path: "/pay",
        component: () => import("@/views/pay/Pay"),
    },
    {
        path: "/pay-ali",
        component: () => import("@/views/pay/PayUseAli"),
    },
    {
        path: "/pay-success",
        component: () => import("@/views/pay/PaySuccess"),
    },

    {
        path: "/pay-error",
        component: () => import("@/views/pay/PayError"),
    },

    {
        path: "/wechat-call",
        component: () => import("@/views/pay/PayWeChatCall"),
    },

    {
        path: "/share",
        component: () => import("@/views/share/share1"),
    },

];

const router = new VueRouter({
    routes,
});

// router.beforeEach((to, from, next) => {
// if (to.name === 'login' || !to.meta.requiresAuth) {
//   return next()
// }

// if (store.state.user) {
//   return next()
// }

// Dialog.confirm({
//   title: '该功能需要登录，确认登录吗？'
// }).then(() => {
//   next({
//     name: 'login',
//     query: {
//       redirect: from.fullPath
//     }
//   })
// }).catch(() => {

// })
// })

export default router;